// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.-inset-4 {
  inset: -1rem;
}
.-inset-6 {
  inset: -1.5rem;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-x-3 {
  left: 0.75rem;
  right: 0.75rem;
}
.inset-x-8 {
  left: 2rem;
  right: 2rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-16 {
  bottom: -4rem;
}
.-bottom-20 {
  bottom: -5rem;
}
.-bottom-24 {
  bottom: -6rem;
}
.-bottom-3 {
  bottom: -0.75rem;
}
.-bottom-4 {
  bottom: -1rem;
}
.-bottom-40 {
  bottom: -10rem;
}
.-bottom-8 {
  bottom: -2rem;
}
.-left-1 {
  left: -0.25rem;
}
.-left-16 {
  left: -4rem;
}
.-left-20 {
  left: -5rem;
}
.-left-24 {
  left: -6rem;
}
.-left-32 {
  left: -8rem;
}
.-left-4 {
  left: -1rem;
}
.-left-40 {
  left: -10rem;
}
.-left-\\[19px\\] {
  left: -19px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-1\\.5 {
  right: -0.375rem;
}
.-right-16 {
  right: -4rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-20 {
  right: -5rem;
}
.-right-24 {
  right: -6rem;
}
.-right-3 {
  right: -0.75rem;
}
.-right-4 {
  right: -1rem;
}
.-right-40 {
  right: -10rem;
}
.-right-48 {
  right: -12rem;
}
.-right-8 {
  right: -2rem;
}
.-right-\\[19px\\] {
  right: -19px;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-16 {
  top: -4rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-20 {
  top: -5rem;
}
.-top-24 {
  top: -6rem;
}
.-top-32 {
  top: -8rem;
}
.-top-4 {
  top: -1rem;
}
.-top-40 {
  top: -10rem;
}
.-top-8 {
  top: -2rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-2\\.5 {
  bottom: 0.625rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-\\[65px\\] {
  bottom: 65px;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-10 {
  left: 2.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-6 {
  left: 1.5rem;
}
.left-8 {
  left: 2rem;
}
.left-\\[12\\.5\\%\\] {
  left: 12.5%;
}
.left-\\[16\\%\\] {
  left: 16%;
}
.left-\\[2px\\] {
  left: 2px;
}
.left-\\[80px\\] {
  left: 80px;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-10 {
  right: 2.5rem;
}
.right-12 {
  right: 3rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[12\\.5\\%\\] {
  right: 12.5%;
}
.right-\\[16\\%\\] {
  right: 16%;
}
.right-full {
  right: 100%;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-12 {
  top: 3rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-20 {
  top: 5rem;
}
.top-28 {
  top: 7rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-6 {
  top: 1.5rem;
}
.top-8 {
  top: 2rem;
}
.top-9 {
  top: 2.25rem;
}
.top-\\[-100px\\] {
  top: -100px;
}
.top-\\[26px\\] {
  top: 26px;
}
.top-\\[2px\\] {
  top: 2px;
}
.top-\\[3\\.25rem\\] {
  top: 3.25rem;
}
.top-\\[30px\\] {
  top: 30px;
}
.top-\\[54px\\] {
  top: 54px;
}
.top-\\[65px\\] {
  top: 65px;
}
.top-\\[calc\\(100\\%\\+12px\\)\\] {
  top: calc(100% + 12px);
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[110\\] {
  z-index: 110;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[55\\] {
  z-index: 55;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[65\\] {
  z-index: 65;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[9990\\] {
  z-index: 9990;
}
.z-\\[9991\\] {
  z-index: 9991;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[9\\] {
  z-index: 9;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-full {
  grid-column: 1 / -1;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-auto {
  margin: auto;
}
.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mr-16 {
  margin-right: -4rem;
}
.-mt-16 {
  margin-top: -4rem;
}
.-mt-20 {
  margin-top: -5rem;
}
.-mt-24 {
  margin-top: -6rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-28 {
  margin-top: 7rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[11px\\] {
  margin-top: 11px;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.mt-\\[3px\\] {
  margin-top: 3px;
}
.mt-auto {
  margin-top: auto;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.\\!hidden {
  display: none !important;
}
.hidden {
  display: none;
}
.aspect-\\[4\\/5\\] {
  aspect-ratio: 4/5;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-72 {
  height: 18rem;
}
.h-8 {
  height: 2rem;
}
.h-80 {
  height: 20rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[0\\.9em\\] {
  height: 0.9em;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[2\\.5px\\] {
  height: 2.5px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[30rem\\] {
  height: 30rem;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[560px\\] {
  height: 560px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[640px\\] {
  height: 640px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[800px\\] {
  height: 800px;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-\\[93vh\\] {
  height: 93vh;
}
.h-\\[95vh\\] {
  height: 95vh;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-64 {
  max-height: 16rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-80 {
  max-height: 20rem;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[220px\\] {
  max-height: 220px;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[60vh\\] {
  max-height: 60vh;
}
.max-h-\\[65vh\\] {
  max-height: 65vh;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[75vh\\] {
  max-height: 75vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[84px\\] {
  max-height: 84px;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[92vh\\] {
  max-height: 92vh;
}
.max-h-\\[95vh\\] {
  max-height: 95vh;
}
.max-h-full {
  max-height: 100%;
}
.max-h-screen {
  max-height: 100vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[128px\\] {
  min-height: 128px;
}
.min-h-\\[140px\\] {
  min-height: 140px;
}
.min-h-\\[150px\\] {
  min-height: 150px;
}
.min-h-\\[2\\.5em\\] {
  min-height: 2.5em;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[350px\\] {
  min-height: 350px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[50vh\\] {
  min-height: 50vh;
}
.min-h-\\[560px\\] {
  min-height: 560px;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[64px\\] {
  min-height: 64px;
}
.min-h-\\[70px\\] {
  min-height: 70px;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[88px\\] {
  min-height: 88px;
}
.min-h-\\[90px\\] {
  min-height: 90px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[30rem\\] {
  width: 30rem;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[34px\\] {
  width: 34px;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[380px\\] {
  width: 380px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[500px\\] {
  width: 500px;
}
.w-\\[52px\\] {
  width: 52px;
}
.w-\\[560px\\] {
  width: 560px;
}
.w-\\[640px\\] {
  width: 640px;
}
.w-\\[70vw\\] {
  width: 70vw;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[82vw\\] {
  width: 82vw;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[92\\%\\] {
  width: 92%;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-\\[calc\\(100vw-2rem\\)\\] {
  width: calc(100vw - 2rem);
}
.w-\\[min\\(20rem\\2c calc\\(100vw-3rem\\)\\)\\] {
  width: min(20rem,calc(100vw - 3rem));
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[45px\\] {
  min-width: 45px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[1000px\\] {
  max-width: 1000px;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[1100px\\] {
  max-width: 1100px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[1300px\\] {
  max-width: 1300px;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[1500px\\] {
  max-width: 1500px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[1600px\\] {
  max-width: 1600px;
}
.max-w-\\[18rem\\] {
  max-width: 18rem;
}
.max-w-\\[190px\\] {
  max-width: 190px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[20rem\\] {
  max-width: 20rem;
}
.max-w-\\[230px\\] {
  max-width: 230px;
}
.max-w-\\[240px\\] {
  max-width: 240px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[440px\\] {
  max-width: 440px;
}
.max-w-\\[520px\\] {
  max-width: 520px;
}
.max-w-\\[540px\\] {
  max-width: 540px;
}
.max-w-\\[560px\\] {
  max-width: 560px;
}
.max-w-\\[580px\\] {
  max-width: 580px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[640px\\] {
  max-width: 640px;
}
.max-w-\\[680px\\] {
  max-width: 680px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[82\\%\\] {
  max-width: 82%;
}
.max-w-\\[85\\%\\] {
  max-width: 85%;
}
.max-w-\\[88\\%\\] {
  max-width: 88%;
}
.max-w-\\[900px\\] {
  max-width: 900px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-screen-sm {
  max-width: 640px;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-none {
  flex: none;
}
.flex-shrink {
  flex-shrink: 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.table-auto {
  table-layout: auto;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-bottom-left {
  transform-origin: bottom left;
}
.origin-bottom-right {
  transform-origin: bottom right;
}
.origin-left {
  transform-origin: left;
}
.origin-top {
  transform-origin: top;
}
.origin-top-left {
  transform-origin: top left;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/3 {
  --tw-translate-x: -33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-3 {
  --tw-translate-x: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/3 {
  --tw-translate-y: -33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/4 {
  --tw-translate-y: -25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-16 {
  --tw-translate-y: -4rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/3 {
  --tw-translate-x: 33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/4 {
  --tw-translate-x: 25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-16 {
  --tw-translate-x: 4rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-3 {
  --tw-translate-x: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6 {
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-7 {
  --tw-translate-x: 1.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[18px\\] {
  --tw-translate-x: 18px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[3px\\] {
  --tw-translate-x: 3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/3 {
  --tw-translate-y: 33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-3 {
  --tw-translate-y: 0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-6 {
  --tw-rotate: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-scale-x-100 {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-y-0 {
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-start {
  scroll-snap-align: start;
}
.scroll-mt-24 {
  scroll-margin-top: 6rem;
}
.scroll-mt-28 {
  scroll-margin-top: 7rem;
}
.scroll-pl-4 {
  scroll-padding-left: 1rem;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(280px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(280px,1fr));
}
.grid-rows-\\[0fr\\] {
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\] {
  grid-template-rows: 1fr;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-center {
  align-content: center;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-1\\.5 {
  column-gap: 0.375rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-2\\.5 {
  row-gap: 0.625rem;
}
.-space-x-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#E5E7EB\\] > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.divide-slate-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.self-stretch {
  align-self: stretch;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.\\!overflow-visible {
  overflow: visible !important;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-clip {
  overflow-x: clip;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.text-balance {
  text-wrap: balance;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[1\\.5rem\\] {
  border-radius: 1.5rem;
}
.rounded-\\[22px\\] {
  border-radius: 22px;
}
.rounded-\\[24px\\] {
  border-radius: 24px;
}
.rounded-\\[28px\\] {
  border-radius: 28px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-\\[2rem\\] {
  border-bottom-right-radius: 2rem;
  border-bottom-left-radius: 2rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-l-2xl {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-tl-none {
  border-top-left-radius: 0px;
}
.rounded-tr-none {
  border-top-right-radius: 0px;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[6px\\] {
  border-width: 6px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-\\[\\#00a884\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 168 132 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1c1d24\\] {
  --tw-border-opacity: 1;
  border-color: rgb(28 29 36 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1f2028\\] {
  --tw-border-opacity: 1;
  border-color: rgb(31 32 40 / var(--tw-border-opacity, 1));
}
.border-\\[\\#23252e\\] {
  --tw-border-opacity: 1;
  border-color: rgb(35 37 46 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2e303a\\] {
  --tw-border-opacity: 1;
  border-color: rgb(46 48 58 / var(--tw-border-opacity, 1));
}
.border-\\[\\#48247f\\]\\/10 {
  border-color: rgb(72 36 127 / 0.1);
}
.border-\\[\\#48247f\\]\\/15 {
  border-color: rgb(72 36 127 / 0.15);
}
.border-\\[\\#48247f\\]\\/20 {
  border-color: rgb(72 36 127 / 0.2);
}
.border-\\[\\#48247f\\]\\/30 {
  border-color: rgb(72 36 127 / 0.3);
}
.border-\\[\\#673AB7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity, 1));
}
.border-\\[\\#673AB7\\]\\/20 {
  border-color: rgb(103 58 183 / 0.2);
}
.border-\\[\\#702cb0\\]\\/20 {
  border-color: rgb(112 44 176 / 0.2);
}
.border-\\[\\#702cb0\\]\\/40 {
  border-color: rgb(112 44 176 / 0.4);
}
.border-\\[\\#8B5CF6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#A7F3D0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BFDBFE\\] {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E5E7EB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E9D5FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EEF2FC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(238 242 252 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EF4444\\] {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FAF8FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(250 248 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FBCFE8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FDE68A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FECACA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-400\\/20 {
  border-color: rgb(52 211 153 / 0.2);
}
.border-emerald-400\\/40 {
  border-color: rgb(52 211 153 / 0.4);
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/50 {
  border-color: rgb(199 210 254 / 0.5);
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-purple-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20 {
  border-color: rgb(239 68 68 / 0.2);
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-sky-600 {
  --tw-border-opacity: 1;
  border-color: rgb(2 132 199 / var(--tw-border-opacity, 1));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/70 {
  border-color: rgb(226 232 240 / 0.7);
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/50 {
  border-color: rgb(51 65 85 / 0.5);
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15 {
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/30 {
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/\\[0\\.05\\] {
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/\\[0\\.06\\] {
  border-color: rgb(255 255 255 / 0.06);
}
.border-white\\/\\[0\\.08\\] {
  border-color: rgb(255 255 255 / 0.08);
}
.border-white\\/\\[0\\.09\\] {
  border-color: rgb(255 255 255 / 0.09);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#673AB7\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(103 58 183 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#8B5CF6\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.border-l-green-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.border-l-red-500 {
  --tw-border-opacity: 1;
  border-left-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-r-gray-800 {
  --tw-border-opacity: 1;
  border-right-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#008f6f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 143 111 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00a884\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 168 132 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#08090d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 9 13 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B1220\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(11 18 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0C4550\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 69 80 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0EA5E9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0d0e13\\]\\/80 {
  background-color: rgb(13 14 19 / 0.8);
}
.bg-\\[\\#0e0f14\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 15 20 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f9d86\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 157 134 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#10B981\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#111219\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(17 18 25 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#121319\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 19 25 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#121319\\]\\/90 {
  background-color: rgb(18 19 25 / 0.9);
}
.bg-\\[\\#12dfbd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 223 189 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#12dfbd\\]\\/15 {
  background-color: rgb(18 223 189 / 0.15);
}
.bg-\\[\\#12dfbd\\]\\/20 {
  background-color: rgb(18 223 189 / 0.2);
}
.bg-\\[\\#161616\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 22 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1c24\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 28 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c1d24\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 29 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e1e2e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#23252e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 37 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#25D366\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(37 211 102 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3B82F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#48247f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(72 36 127 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#48247f\\]\\/10 {
  background-color: rgb(72 36 127 / 0.1);
}
.bg-\\[\\#5c5f6b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(92 95 107 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#673AB7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#673AB7\\]\\/10 {
  background-color: rgb(103 58 183 / 0.1);
}
.bg-\\[\\#673AB7\\]\\/60 {
  background-color: rgb(103 58 183 / 0.6);
}
.bg-\\[\\#702cb0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(112 44 176 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#702cb0\\]\\/0 {
  background-color: rgb(112 44 176 / 0);
}
.bg-\\[\\#702cb0\\]\\/10 {
  background-color: rgb(112 44 176 / 0.1);
}
.bg-\\[\\#8B5CF6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#9CA3AF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C4B5FD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D1FAE5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DBEAFE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0F2FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5E7EB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E9D5FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDE9FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EEF2FC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EEF2FC\\]\\/50 {
  background-color: rgb(238 242 252 / 0.5);
}
.bg-\\[\\#EF4444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3E8FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F3F4F6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F46653\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 102 83 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F46653\\]\\/10 {
  background-color: rgb(244 102 83 / 0.1);
}
.bg-\\[\\#F59E0B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F3FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FAF8FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 248 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FCE7F3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEE2E2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEF2F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FEF3C7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d9fdd3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(217 253 211 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#dcf8c6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(220 248 198 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e3faf5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 250 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#efeae2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 234 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0eaf8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 234 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f2f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 242 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1ecfa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 236 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1ecfa\\]\\/60 {
  background-color: rgb(241 236 250 / 0.6);
}
.bg-\\[\\#f1f5fb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f2ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 242 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f3fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(246 243 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#faf7ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 247 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#faf9fc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(250 249 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#faf9fc\\]\\/95 {
  background-color: rgb(250 249 252 / 0.95);
}
.bg-\\[\\#fbf7ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 247 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fbf9ff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 249 255 / var(--tw-bg-opacity, 1));
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/5 {
  background-color: rgb(0 0 0 / 0.05);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55 {
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/65 {
  background-color: rgb(0 0 0 / 0.65);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/95 {
  background-color: rgb(0 0 0 / 0.95);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/10 {
  background-color: rgb(59 130 246 / 0.1);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/10 {
  background-color: rgb(52 211 153 / 0.1);
}
.bg-emerald-400\\/80 {
  background-color: rgb(52 211 153 / 0.8);
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-400\\/15 {
  background-color: rgb(232 121 249 / 0.15);
}
.bg-fuchsia-400\\/20 {
  background-color: rgb(232 121 249 / 0.2);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/50 {
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-gray-900\\/50 {
  background-color: rgb(17 24 39 / 0.5);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/50 {
  background-color: rgb(240 253 244 / 0.5);
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-300\\/20 {
  background-color: rgb(165 180 252 / 0.2);
}
.bg-indigo-300\\/30 {
  background-color: rgb(165 180 252 / 0.3);
}
.bg-indigo-400\\/15 {
  background-color: rgb(129 140 248 / 0.15);
}
.bg-indigo-400\\/20 {
  background-color: rgb(129 140 248 / 0.2);
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/50 {
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-300\\/20 {
  background-color: rgb(216 180 254 / 0.2);
}
.bg-purple-300\\/30 {
  background-color: rgb(216 180 254 / 0.3);
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/10 {
  background-color: rgb(168 85 247 / 0.1);
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-950\\/30 {
  background-color: rgb(2 6 23 / 0.3);
}
.bg-slate-950\\/40 {
  background-color: rgb(2 6 23 / 0.4);
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15 {
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60 {
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/\\[0\\.03\\] {
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.04\\] {
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.06\\] {
  background-color: rgb(255 255 255 / 0.06);
}
.bg-white\\/\\[0\\.07\\] {
  background-color: rgb(255 255 255 / 0.07);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-opacity-0 {
  --tw-bg-opacity: 0;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-\\[linear-gradient\\(to_bottom_right\\2c \\#f8fbff\\2c \\#eef5ff\\)\\] {
  background-image: linear-gradient(to bottom right,#f8fbff,#eef5ff);
}
.bg-\\[linear-gradient\\(to_right\\2c \\#ffffff10_1px\\2c transparent_1px\\)\\2c linear-gradient\\(to_bottom\\2c \\#ffffff10_1px\\2c transparent_1px\\)\\] {
  background-image: linear-gradient(to right,#ffffff10 1px,transparent 1px),linear-gradient(to bottom,#ffffff10 1px,transparent 1px);
}
.bg-\\[radial-gradient\\(60\\%_50\\%_at_0\\%_0\\%\\2c rgba\\(112\\2c 44\\2c 176\\2c 0\\.14\\)\\2c transparent\\)\\2c radial-gradient\\(50\\%_45\\%_at_100\\%_100\\%\\2c rgba\\(18\\2c 223\\2c 189\\2c 0\\.16\\)\\2c transparent\\)\\2c radial-gradient\\(40\\%_35\\%_at_100\\%_0\\%\\2c rgba\\(72\\2c 36\\2c 127\\2c 0\\.08\\)\\2c transparent\\)\\] {
  background-image: radial-gradient(60% 50% at 0% 0%,rgba(112,44,176,0.14),transparent),radial-gradient(50% 45% at 100% 100%,rgba(18,223,189,0.16),transparent),radial-gradient(40% 35% at 100% 0%,rgba(72,36,127,0.08),transparent);
}
.bg-\\[radial-gradient\\(circle\\2c rgba\\(18\\2c 223\\2c 189\\2c 0\\.28\\)\\2c transparent_65\\%\\)\\] {
  background-image: radial-gradient(circle,rgba(18,223,189,0.28),transparent 65%);
}
.bg-\\[radial-gradient\\(circle_at_center\\2c _\\#1b1c25_0\\%\\2c _\\#101118_75\\%\\)\\] {
  background-image: radial-gradient(circle at center, #1b1c25 0%, #101118 75%);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#08090d\\] {
  --tw-gradient-from: #08090d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 9 13 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#12dfbd\\] {
  --tw-gradient-from: #12dfbd var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(18 223 189 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#28194f\\] {
  --tw-gradient-from: #28194f var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(40 25 79 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#28194f\\]\\/15 {
  --tw-gradient-from: rgb(40 25 79 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(40 25 79 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#28194f\\]\\/90 {
  --tw-gradient-from: rgb(40 25 79 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(40 25 79 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#3b3a89\\] {
  --tw-gradient-from: #3b3a89 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 58 137 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#48247f\\] {
  --tw-gradient-from: #48247f var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(72 36 127 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#673AB7\\] {
  --tw-gradient-from: #673AB7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(103 58 183 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#702cb0\\] {
  --tw-gradient-from: #702cb0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(112 44 176 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#8B5CF6\\] {
  --tw-gradient-from: #8B5CF6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#EEF2FC\\] {
  --tw-gradient-from: #EEF2FC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F3E8FF\\] {
  --tw-gradient-from: #F3E8FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#e3faf5\\] {
  --tw-gradient-from: #e3faf5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(227 250 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#ef6f6c\\] {
  --tw-gradient-from: #ef6f6c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 111 108 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#effbf8\\] {
  --tw-gradient-from: #effbf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 251 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#f0eaf8\\] {
  --tw-gradient-from: #f0eaf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 234 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#f1ecfa\\] {
  --tw-gradient-from: #f1ecfa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 236 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#f6f3fc\\] {
  --tw-gradient-from: #f6f3fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(246 243 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#fbf7ff\\] {
  --tw-gradient-from: #fbf7ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 247 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500 {
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/75 {
  --tw-gradient-from: rgb(0 0 0 / 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400 {
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50 {
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500 {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600\\/20 {
  --tw-gradient-from: rgb(37 99 235 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600\\/30 {
  --tw-gradient-from: rgb(37 99 235 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-800 {
  --tw-gradient-from: #1e40af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 64 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-900\\/40 {
  --tw-gradient-from: rgb(30 58 138 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500 {
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-500 {
  --tw-gradient-from: #d946ef var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 70 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50 {
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500 {
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-100 {
  --tw-gradient-from: #e0e7ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50 {
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500 {
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600 {
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500 {
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pastel-blue-100 {
  --tw-gradient-from: #d4e6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(212 230 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pastel-blue-400 {
  --tw-gradient-from: #7aa9ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(122 169 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500 {
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-sky-500 {
  --tw-gradient-from: #0ea5e9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(14 165 233 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-900 {
  --tw-gradient-from: #0f172a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 23 42 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white {
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#08090d\\]\\/95 {
  --tw-gradient-to: rgb(8 9 13 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(8 9 13 / 0.95) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#23252e\\] {
  --tw-gradient-to: rgb(35 37 46 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #23252e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#28194f\\]\\/25 {
  --tw-gradient-to: rgb(40 25 79 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(40 25 79 / 0.25) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#48247f\\] {
  --tw-gradient-to: rgb(72 36 127 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #48247f var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#5a2a94\\] {
  --tw-gradient-to: rgb(90 42 148 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #5a2a94 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#702cb0\\] {
  --tw-gradient-to: rgb(112 44 176 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #702cb0 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#702cb0\\]\\/40 {
  --tw-gradient-to: rgb(112 44 176 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(112 44 176 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#c9b5ff\\] {
  --tw-gradient-to: rgb(201 181 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #c9b5ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/40 {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-400 {
  --tw-gradient-to: rgb(129 140 248 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #818cf8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-50 {
  --tw-gradient-to: rgb(238 242 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #eef2ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-50\\/60 {
  --tw-gradient-to: rgb(238 242 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(238 242 255 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-500\\/20 {
  --tw-gradient-to: rgb(99 102 241 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(99 102 241 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500 {
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-slate-700 {
  --tw-gradient-to: rgb(51 65 85 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #334155 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/40 {
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0f9d86\\] {
  --tw-gradient-to: #0f9d86 var(--tw-gradient-to-position);
}
.to-\\[\\#12dfbd\\] {
  --tw-gradient-to: #12dfbd var(--tw-gradient-to-position);
}
.to-\\[\\#48247f\\] {
  --tw-gradient-to: #48247f var(--tw-gradient-to-position);
}
.to-\\[\\#5c58b8\\] {
  --tw-gradient-to: #5c58b8 var(--tw-gradient-to-position);
}
.to-\\[\\#673AB7\\] {
  --tw-gradient-to: #673AB7 var(--tw-gradient-to-position);
}
.to-\\[\\#702cb0\\] {
  --tw-gradient-to: #702cb0 var(--tw-gradient-to-position);
}
.to-\\[\\#8B5CF6\\] {
  --tw-gradient-to: #8B5CF6 var(--tw-gradient-to-position);
}
.to-\\[\\#EDE9FE\\] {
  --tw-gradient-to: #EDE9FE var(--tw-gradient-to-position);
}
.to-\\[\\#c94a47\\] {
  --tw-gradient-to: #c94a47 var(--tw-gradient-to-position);
}
.to-\\[\\#c9b5ff\\] {
  --tw-gradient-to: #c9b5ff var(--tw-gradient-to-position);
}
.to-\\[\\#e3faf5\\] {
  --tw-gradient-to: #e3faf5 var(--tw-gradient-to-position);
}
.to-\\[\\#e8faf5\\] {
  --tw-gradient-to: #e8faf5 var(--tw-gradient-to-position);
}
.to-\\[\\#effbf8\\] {
  --tw-gradient-to: #effbf8 var(--tw-gradient-to-position);
}
.to-\\[\\#f1ecfa\\] {
  --tw-gradient-to: #f1ecfa var(--tw-gradient-to-position);
}
.to-\\[\\#f6f3fc\\] {
  --tw-gradient-to: #f6f3fc var(--tw-gradient-to-position);
}
.to-\\[\\#fbf7ff\\] {
  --tw-gradient-to: #fbf7ff var(--tw-gradient-to-position);
}
.to-blue-600 {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-blue-800 {
  --tw-gradient-to: #1e40af var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-emerald-500 {
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-gray-100 {
  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position);
}
.to-green-700 {
  --tw-gradient-to: #15803d var(--tw-gradient-to-position);
}
.to-indigo-500 {
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-600 {
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-orange-500 {
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-600 {
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-pastel-pink-100 {
  --tw-gradient-to: #ffd9e6 var(--tw-gradient-to-position);
}
.to-pastel-pink-400 {
  --tw-gradient-to: #ff8ab3 var(--tw-gradient-to-position);
}
.to-pink-500 {
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-purple-100 {
  --tw-gradient-to: #f3e8ff var(--tw-gradient-to-position);
}
.to-purple-400 {
  --tw-gradient-to: #c084fc var(--tw-gradient-to-position);
}
.to-purple-50 {
  --tw-gradient-to: #faf5ff var(--tw-gradient-to-position);
}
.to-purple-50\\/60 {
  --tw-gradient-to: rgb(250 245 255 / 0.6) var(--tw-gradient-to-position);
}
.to-purple-500 {
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-600 {
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-600\\/20 {
  --tw-gradient-to: rgb(147 51 234 / 0.2) var(--tw-gradient-to-position);
}
.to-purple-600\\/30 {
  --tw-gradient-to: rgb(147 51 234 / 0.3) var(--tw-gradient-to-position);
}
.to-purple-900\\/40 {
  --tw-gradient-to: rgb(88 28 135 / 0.4) var(--tw-gradient-to-position);
}
.to-red-500 {
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-rose-500 {
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-rose-600 {
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}
.to-slate-50 {
  --tw-gradient-to: #f8fafc var(--tw-gradient-to-position);
}
.to-slate-800 {
  --tw-gradient-to: #1e293b var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.bg-\\[size\\:40px_40px\\] {
  background-size: 40px 40px;
}
.bg-cover {
  background-size: cover;
}
.bg-clip-text {
  background-clip: text;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-\\[\\#8B5CF6\\] {
  fill: #8B5CF6;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.p-8 {
  padding: 2rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-14 {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-44 {
  padding-top: 11rem;
  padding-bottom: 11rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-14 {
  padding-bottom: 3.5rem;
}
.pb-16 {
  padding-bottom: 4rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-32 {
  padding-bottom: 8rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[max\\(0\\.5rem\\2c env\\(safe-area-inset-bottom\\)\\)\\] {
  padding-bottom: max(0.5rem,env(safe-area-inset-bottom));
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-3\\.5 {
  padding-left: 0.875rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[4\\.25rem\\] {
  padding-left: 4.25rem;
}
.pr-0 {
  padding-right: 0px;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-1\\.5 {
  padding-right: 0.375rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-20 {
  padding-right: 5rem;
}
.pr-24 {
  padding-right: 6rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-24 {
  padding-top: 6rem;
}
.pt-28 {
  padding-top: 7rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-40 {
  padding-top: 10rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.font-\\[Inter\\2c ui-sans-serif\\2c system-ui\\2c sans-serif\\] {
  font-family: Inter,ui-sans-serif,system-ui,sans-serif;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-7xl {
  font-size: 4.5rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.5px\\] {
  font-size: 11.5px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12\\.5px\\] {
  font-size: 12.5px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14\\.5px\\] {
  font-size: 14.5px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[19px\\] {
  font-size: 19px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[8\\.5px\\] {
  font-size: 8.5px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.not-italic {
  font-style: normal;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-\\[1\\.25\\] {
  line-height: 1.25;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1\\.6\\] {
  line-height: 1.6;
}
.leading-\\[1\\.75\\] {
  line-height: 1.75;
}
.leading-\\[1\\.7\\] {
  line-height: 1.7;
}
.leading-\\[1\\.85\\] {
  line-height: 1.85;
}
.leading-\\[1\\.8\\] {
  line-height: 1.8;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.005em\\] {
  letter-spacing: 0.005em;
}
.tracking-\\[0\\.015em\\] {
  letter-spacing: 0.015em;
}
.tracking-\\[0\\.01em\\] {
  letter-spacing: 0.01em;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\] {
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-\\[2px\\] {
  letter-spacing: 2px;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#00AD8C\\] {
  --tw-text-opacity: 1;
  color: rgb(0 173 140 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00a884\\] {
  --tw-text-opacity: 1;
  color: rgb(0 168 132 / var(--tw-text-opacity, 1));
}
.text-\\[\\#047857\\] {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-\\[\\#062b21\\] {
  --tw-text-opacity: 1;
  color: rgb(6 43 33 / var(--tw-text-opacity, 1));
}
.text-\\[\\#075985\\] {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0C4550\\] {
  --tw-text-opacity: 1;
  color: rgb(12 69 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0b6b5a\\] {
  --tw-text-opacity: 1;
  color: rgb(11 107 90 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0f9d86\\] {
  --tw-text-opacity: 1;
  color: rgb(15 157 134 / var(--tw-text-opacity, 1));
}
.text-\\[\\#102b37\\] {
  --tw-text-opacity: 1;
  color: rgb(16 43 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#10B981\\] {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-\\[\\#12dfbd\\] {
  --tw-text-opacity: 1;
  color: rgb(18 223 189 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1877F2\\] {
  --tw-text-opacity: 1;
  color: rgb(24 119 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D4ED8\\] {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1F2937\\] {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#28194f\\] {
  --tw-text-opacity: 1;
  color: rgb(40 25 79 / var(--tw-text-opacity, 1));
}
.text-\\[\\#374151\\] {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3b2a63\\] {
  --tw-text-opacity: 1;
  color: rgb(59 42 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#48247f\\] {
  --tw-text-opacity: 1;
  color: rgb(72 36 127 / var(--tw-text-opacity, 1));
}
.text-\\[\\#48247f\\]\\/15 {
  color: rgb(72 36 127 / 0.15);
}
.text-\\[\\#4B5563\\] {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4C1D95\\] {
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4C2D85\\] {
  --tw-text-opacity: 1;
  color: rgb(76 45 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5E35A6\\] {
  --tw-text-opacity: 1;
  color: rgb(94 53 166 / var(--tw-text-opacity, 1));
}
.text-\\[\\#673AB7\\] {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B7280\\] {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b6f7b\\] {
  --tw-text-opacity: 1;
  color: rgb(107 111 123 / var(--tw-text-opacity, 1));
}
.text-\\[\\#702cb0\\] {
  --tw-text-opacity: 1;
  color: rgb(112 44 176 / var(--tw-text-opacity, 1));
}
.text-\\[\\#702cb0\\]\\/70 {
  color: rgb(112 44 176 / 0.7);
}
.text-\\[\\#702cb0\\]\\/80 {
  color: rgb(112 44 176 / 0.8);
}
.text-\\[\\#767b87\\] {
  --tw-text-opacity: 1;
  color: rgb(118 123 135 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8B5CF6\\] {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8a8f9c\\] {
  --tw-text-opacity: 1;
  color: rgb(138 143 156 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9CA3AF\\] {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9aa0ab\\] {
  --tw-text-opacity: 1;
  color: rgb(154 160 171 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B45309\\] {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B91C1C\\] {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-\\[\\#BE185D\\] {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C4B5FD\\] {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D1D5DB\\] {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E5E7EB\\] {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EF4444\\] {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F46653\\] {
  --tw-text-opacity: 1;
  color: rgb(244 102 83 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c7cad1\\] {
  --tw-text-opacity: 1;
  color: rgb(199 202 209 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e2e3e8\\] {
  --tw-text-opacity: 1;
  color: rgb(226 227 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f1f2f5\\] {
  --tw-text-opacity: 1;
  color: rgb(241 242 245 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f5a623\\] {
  --tw-text-opacity: 1;
  color: rgb(245 166 35 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-emerald-300 {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-200 {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-indigo-200 {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.text-indigo-300 {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-800 {
  --tw-text-opacity: 1;
  color: rgb(154 52 18 / var(--tw-text-opacity, 1));
}
.text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(157 23 77 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity, 1));
}
.text-sky-700 {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity, 1));
}
.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity, 1));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/75 {
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85 {
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.decoration-\\[\\#702cb0\\]\\/30 {
  text-decoration-color: rgb(112 44 176 / 0.3);
}
.decoration-\\[\\#702cb0\\]\\/40 {
  text-decoration-color: rgb(112 44 176 / 0.4);
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#673AB7\\] {
  accent-color: #673AB7;
}
.accent-purple-600 {
  accent-color: #9333ea;
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-\\[0\\.35\\] {
  opacity: 0.35;
}
.opacity-\\[0\\.55\\] {
  opacity: 0.55;
}
.opacity-\\[0\\.65\\] {
  opacity: 0.65;
}
.mix-blend-multiply {
  mix-blend-mode: multiply;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-3px_0_12px_rgba\\(103\\2c 58\\2c 183\\2c 0\\.30\\)\\] {
  --tw-shadow: -3px 0 12px rgba(103,58,183,0.30);
  --tw-shadow-colored: -3px 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_14px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 0 14px rgba(239,68,68,0.15);
  --tw-shadow-colored: 0 0 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_\\#12dfbd\\] {
  --tw-shadow: 0 0 8px #12dfbd;
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(239\\2c 68\\2c 68\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 0 8px rgba(239,68,68,0.6);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(251\\2c 191\\2c 36\\2c 0\\.6\\)\\] {
  --tw-shadow: 0 0 8px rgba(251,191,36,0.6);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(52\\2c 211\\2c 153\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 0 8px rgba(52,211,153,0.7);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 0 8px rgba(72,36,127,0.35);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 12px 32px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
  --tw-shadow: 0 16px 40px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_48px_rgba\\(40\\2c 25\\2c 79\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 16px 48px rgba(40,25,79,0.12);
  --tw-shadow-colored: 0 16px 48px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_40px_-16px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 20px 40px -16px rgba(72,36,127,0.35);
  --tw-shadow-colored: 0 20px 40px -16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_-20px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.55\\)\\] {
  --tw-shadow: 0 20px 50px -20px rgba(72,36,127,0.55);
  --tw-shadow-colored: 0 20px 50px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 20px 50px rgba(0,0,0,0.15);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_-20px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 20px 60px -20px rgba(72,36,127,0.25);
  --tw-shadow-colored: 0 20px 60px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgba\\(40\\2c 25\\2c 79\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 20px 60px rgba(40,25,79,0.15);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_48px_-12px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 24px 48px -12px rgba(72,36,127,0.2);
  --tw-shadow-colored: 0 24px 48px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_-20px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.35\\)\\] {
  --tw-shadow: 0 24px 60px -20px rgba(72,36,127,0.35);
  --tw-shadow-colored: 0 24px 60px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_-20px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.55\\)\\] {
  --tw-shadow: 0 24px 60px -20px rgba(72,36,127,0.55);
  --tw-shadow-colored: 0 24px 60px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_-24px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.4\\)\\] {
  --tw-shadow: 0 24px 60px -24px rgba(72,36,127,0.4);
  --tw-shadow-colored: 0 24px 60px -24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_-24px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.55\\)\\] {
  --tw-shadow: 0 24px 60px -24px rgba(72,36,127,0.55);
  --tw-shadow-colored: 0 24px 60px -24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_70px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 0 24px 70px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 24px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_10px_-6px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 2px 10px -6px rgba(72,36,127,0.18);
  --tw-shadow-colored: 0 2px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_10px_rgba\\(18\\2c 223\\2c 189\\2c 0\\.3\\)\\] {
  --tw-shadow: 0 2px 10px rgba(18,223,189,0.3);
  --tw-shadow-colored: 0 2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_8px_rgba\\(18\\2c 223\\2c 189\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 2px 8px rgba(18,223,189,0.25);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_80px_-30px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.7\\)\\] {
  --tw-shadow: 0 30px 80px -30px rgba(72,36,127,0.7);
  --tw-shadow-colored: 0 30px 80px -30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_20px_-8px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 4px 20px -8px rgba(72,36,127,0.12);
  --tw-shadow-colored: 0 4px 20px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_24px_rgba\\(40\\2c 25\\2c 79\\2c 0\\.06\\)\\] {
  --tw-shadow: 0 4px 24px rgba(40,25,79,0.06);
  --tw-shadow-colored: 0 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_24px_rgba\\(40\\2c 25\\2c 79\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 4px 24px rgba(40,25,79,0.08);
  --tw-shadow-colored: 0 4px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_20px_-10px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.2\\)\\] {
  --tw-shadow: 0 6px 20px -10px rgba(72,36,127,0.2);
  --tw-shadow-colored: 0 6px 20px -10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(52\\2c 211\\2c 153\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 8px 24px rgba(52,211,153,0.18);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_-12px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.22\\)\\] {
  --tw-shadow: 0 8px 30px -12px rgba(72,36,127,0.22);
  --tw-shadow-colored: 0 8px 30px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_-12px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 8px 30px -12px rgba(72,36,127,0.25);
  --tw-shadow-colored: 0 8px 30px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_-14px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.22\\)\\] {
  --tw-shadow: 0 8px 30px -14px rgba(72,36,127,0.22);
  --tw-shadow-colored: 0 8px 30px -14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_-14px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 8px 30px -14px rgba(72,36,127,0.25);
  --tw-shadow-colored: 0 8px 30px -14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_30px_rgb\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 8px 30px rgb(0,0,0,0.04);
  --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[\\#12dfbd\\]\\/20 {
  --tw-shadow-color: rgb(18 223 189 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[\\#48247f\\]\\/20 {
  --tw-shadow-color: rgb(72 36 127 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-\\[\\#48247f\\]\\/25 {
  --tw-shadow-color: rgb(72 36 127 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-900\\/30 {
  --tw-shadow-color: rgb(30 58 138 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/25 {
  --tw-shadow-color: rgb(168 85 247 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-\\[\\#00a884\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 168 132 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#48247f\\]\\/10 {
  --tw-ring-color: rgb(72 36 127 / 0.1);
}
.ring-\\[\\#702cb0\\]\\/20 {
  --tw-ring-color: rgb(112 44 176 / 0.2);
}
.ring-green-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}
.ring-red-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.ring-slate-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl {
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl {
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm {
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-2xl {
  --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur {
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[3px\\] {
  --tw-backdrop-blur: blur(3px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-lg {
  --tw-backdrop-blur: blur(16px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl {
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter {
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\] {
  transition-property: border-color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\] {
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[-ms-overflow-style\\:none\\] {
  -ms-overflow-style: none;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}

/* Smooth theme transition */
html {
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Thin Scrollbar */
.scrollbar-thin::-webkit-scrollbar {
  width: 4px;
  /* thin */
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: transparent;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #181818;
  border-radius: 10px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: #151515;
}

/* For Firefox */
.scrollbar-thin {
  scrollbar-width: thin;
  scrollbar-color: #363636 transparent;
}
.file\\:mr-2::file-selector-button {
  margin-right: 0.5rem;
}
.file\\:mr-3::file-selector-button {
  margin-right: 0.75rem;
}
.file\\:mr-4::file-selector-button {
  margin-right: 1rem;
}
.file\\:rounded::file-selector-button {
  border-radius: 0.25rem;
}
.file\\:rounded-lg::file-selector-button {
  border-radius: 0.5rem;
}
.file\\:rounded-md::file-selector-button {
  border-radius: 0.375rem;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-\\[\\#F3E8FF\\]::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.file\\:bg-blue-50::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.file\\:bg-purple-50::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.file\\:px-3::file-selector-button {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:px-4::file-selector-button {
  padding-left: 1rem;
  padding-right: 1rem;
}
.file\\:py-1::file-selector-button {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.file\\:py-1\\.5::file-selector-button {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.file\\:py-2::file-selector-button {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:text-xs::file-selector-button {
  font-size: 0.75rem;
  line-height: 1rem;
}
.file\\:font-semibold::file-selector-button {
  font-weight: 600;
}
.file\\:text-\\[\\#5E35A6\\]::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(94 53 166 / var(--tw-text-opacity, 1));
}
.file\\:text-\\[\\#5e35a6\\]::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(94 53 166 / var(--tw-text-opacity, 1));
}
.file\\:text-\\[\\#673AB7\\]::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity, 1));
}
.file\\:text-blue-700::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-\\[\\#555965\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(85 89 101 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-slate-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:-inset-2\\.5::before {
  content: var(--tw-content);
  inset: -0.625rem;
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:left-\\[2px\\]::after {
  content: var(--tw-content);
  left: 2px;
}
.after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}
.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}
.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}
.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}
.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}
.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.last\\:mb-0:last-child {
  margin-bottom: 0px;
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
.last\\:pb-0:last-child {
  padding-bottom: 0px;
}
.odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.even\\:bg-slate-50\\/60:nth-child(even) {
  background-color: rgb(248 250 252 / 0.6);
}
.open\\:border-\\[\\#702cb0\\]\\/30[open] {
  border-color: rgb(112 44 176 / 0.3);
}
.open\\:border-\\[\\#702cb0\\]\\/40[open] {
  border-color: rgb(112 44 176 / 0.4);
}
.open\\:border-slate-300[open] {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.open\\:bg-\\[\\#fcfaff\\][open] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 250 255 / var(--tw-bg-opacity, 1));
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1:hover {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-1\\.5:hover {
  --tw-translate-y: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-2:hover {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-px:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:translate-x-1:hover {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#12dfbd\\]\\/60:hover {
  border-color: rgb(18 223 189 / 0.6);
}
.hover\\:border-\\[\\#48247f\\]\\/30:hover {
  border-color: rgb(72 36 127 / 0.3);
}
.hover\\:border-\\[\\#673AB7\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#673AB7\\]\\/30:hover {
  border-color: rgb(103 58 183 / 0.3);
}
.hover\\:border-\\[\\#673AB7\\]\\/40:hover {
  border-color: rgb(103 58 183 / 0.4);
}
.hover\\:border-\\[\\#702cb0\\]\\/30:hover {
  border-color: rgb(112 44 176 / 0.3);
}
.hover\\:border-\\[\\#702cb0\\]\\/40:hover {
  border-color: rgb(112 44 176 / 0.4);
}
.hover\\:border-\\[\\#702cb0\\]\\/50:hover {
  border-color: rgb(112 44 176 / 0.5);
}
.hover\\:border-\\[\\#8B5CF6\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#E9D5FF\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#EF4444\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.hover\\:border-emerald-400\\/30:hover {
  border-color: rgb(52 211 153 / 0.3);
}
.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.hover\\:border-green-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.hover\\:border-green-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.hover\\:border-purple-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.hover\\:border-red-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(254 226 226 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.hover\\:border-slate-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#008f6f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 143 111 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#0284C7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#059669\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#161720\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 23 32 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#20bd5a\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(32 189 90 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#2563eb\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#40f0d3\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(64 240 211 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#48247f\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(72 36 127 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#512DA8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(81 45 168 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#5E35A6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(94 53 166 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#5a2fa0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(90 47 160 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#5e35a6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(94 53 166 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#673AB7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#A7F3D0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#B91C1C\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#BAE6FD\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#D1FAE5\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#D97706\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#E5E7EB\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#E9D5FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#EEF2FC\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F3E8FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#F3E8FF\\]\\/30:hover {
  background-color: rgb(243 232 255 / 0.3);
}
.hover\\:bg-\\[\\#F3F4F6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FAF8FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 248 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FECACA\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#FEF2F2\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f0eaf8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 234 248 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f1ecfa\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 236 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f3edff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 237 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f5f6f6\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(245 246 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f6f2ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#f6f3fc\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(246 243 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#fbf7ff\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 247 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/5:hover {
  background-color: rgb(0 0 0 / 0.05);
}
.hover\\:bg-black\\/70:hover {
  background-color: rgb(0 0 0 / 0.7);
}
.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-orange-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-purple-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-500\\/20:hover {
  background-color: rgb(239 68 68 / 0.2);
}
.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-teal-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-white\\/40:hover {
  background-color: rgb(255 255 255 / 0.4);
}
.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}
.hover\\:bg-white\\/\\[0\\.08\\]:hover {
  background-color: rgb(255 255 255 / 0.08);
}
.hover\\:bg-white\\/\\[0\\.12\\]:hover {
  background-color: rgb(255 255 255 / 0.12);
}
.hover\\:bg-yellow-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-opacity-90:hover {
  --tw-bg-opacity: 0.9;
}
.hover\\:from-\\[\\#673AB7\\]:hover {
  --tw-gradient-from: #673AB7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(103 58 183 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-blue-500:hover {
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:from-green-700:hover {
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\\:to-\\[\\#5E35A6\\]:hover {
  --tw-gradient-to: #5E35A6 var(--tw-gradient-to-position);
}
.hover\\:to-green-800:hover {
  --tw-gradient-to: #166534 var(--tw-gradient-to-position);
}
.hover\\:to-indigo-500:hover {
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.hover\\:text-\\[\\#008c73\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(0 140 115 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#059669\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#09323A\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(9 50 58 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#0C4550\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(12 69 80 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#374151\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#48247f\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(72 36 127 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#4C2D85\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(76 45 133 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#512DA8\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(81 45 168 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#5E35A6\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(94 53 166 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#5e35a6\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(94 53 166 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#673AB7\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#702cb0\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(112 44 176 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#B91C1C\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#E9D5FF\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#EF4444\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#b0b4bf\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(176 180 191 / var(--tw-text-opacity, 1));
}
.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-900:hover {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-700:hover {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-800:hover {
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.hover\\:text-green-900:hover {
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-500:hover {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-800:hover {
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}
.hover\\:text-indigo-900:hover {
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-800:hover {
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.hover\\:text-purple-900:hover {
  --tw-text-opacity: 1;
  color: rgb(88 28 135 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-900:hover {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.hover\\:text-rose-800:hover {
  --tw-text-opacity: 1;
  color: rgb(159 18 57 / var(--tw-text-opacity, 1));
}
.hover\\:text-sky-800:hover {
  --tw-text-opacity: 1;
  color: rgb(7 89 133 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-600:hover {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-700:hover {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-800:hover {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.hover\\:text-yellow-900:hover {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.hover\\:text-opacity-80:hover {
  --tw-text-opacity: 0.8;
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:decoration-\\[\\#48247f\\]:hover {
  text-decoration-color: #48247f;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_16px_32px_-12px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.35\\)\\]:hover {
  --tw-shadow: 0 16px 32px -12px rgba(72,36,127,0.35);
  --tw-shadow-colored: 0 16px 32px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_20px_40px_-12px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.25\\)\\]:hover {
  --tw-shadow: 0 20px 40px -12px rgba(72,36,127,0.25);
  --tw-shadow-colored: 0 20px 40px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_24px_48px_-12px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.35\\)\\]:hover {
  --tw-shadow: 0 24px 48px -12px rgba(72,36,127,0.35);
  --tw-shadow-colored: 0 24px 48px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_24px_48px_-12px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.4\\)\\]:hover {
  --tw-shadow: 0 24px 48px -12px rgba(72,36,127,0.4);
  --tw-shadow-colored: 0 24px 48px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_4px_14px_rgba\\(18\\2c 223\\2c 189\\2c 0\\.35\\)\\]:hover {
  --tw-shadow: 0 4px 14px rgba(18,223,189,0.35);
  --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_6px_20px_rgba\\(18\\2c 223\\2c 189\\2c 0\\.45\\)\\]:hover {
  --tw-shadow: 0 6px 20px rgba(18,223,189,0.45);
  --tw-shadow-colored: 0 6px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_8px_16px_-8px_rgba\\(72\\2c 36\\2c 127\\2c 0\\.28\\)\\]:hover {
  --tw-shadow: 0 8px 16px -8px rgba(72,36,127,0.28);
  --tw-shadow-colored: 0 8px 16px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[\\#12dfbd\\]\\/40:hover {
  --tw-shadow-color: rgb(18 223 189 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-\\[\\#48247f\\]\\/40:hover {
  --tw-shadow-color: rgb(72 36 127 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:shadow-purple-500\\/40:hover {
  --tw-shadow-color: rgb(168 85 247 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.hover\\:ring-2:hover {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.hover\\:ring-gray-400:hover {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
.hover\\:file\\:bg-\\[\\#E9D5FF\\]::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.hover\\:file\\:bg-blue-100::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.hover\\:file\\:bg-purple-100::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.focus\\:not-sr-only:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.focus\\:fixed:focus {
  position: fixed;
}
.focus\\:left-4:focus {
  left: 1rem;
}
.focus\\:top-4:focus {
  top: 1rem;
}
.focus\\:z-10:focus {
  z-index: 10;
}
.focus\\:z-\\[10000\\]:focus {
  z-index: 10000;
}
.focus\\:rounded-md:focus {
  border-radius: 0.375rem;
}
.focus\\:border-\\[\\#673AB7\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[\\#702cb0\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(112 44 176 / var(--tw-border-opacity, 1));
}
.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.focus\\:border-emerald-400\\/60:focus {
  border-color: rgb(52 211 153 / 0.6);
}
.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity, 1));
}
.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.focus\\:border-transparent:focus {
  border-color: transparent;
}
.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.focus\\:px-4:focus {
  padding-left: 1rem;
  padding-right: 1rem;
}
.focus\\:py-2:focus {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.focus\\:text-sm:focus {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.focus\\:font-medium:focus {
  font-weight: 500;
}
.focus\\:text-\\[\\#48247f\\]:focus {
  --tw-text-opacity: 1;
  color: rgb(72 36 127 / var(--tw-text-opacity, 1));
}
.focus\\:shadow-lg:focus {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-\\[\\#673AB7\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(103 58 183 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#702cb0\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(112 44 176 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#702cb0\\]\\/20:focus {
  --tw-ring-color: rgb(112 44 176 / 0.2);
}
.focus\\:ring-\\[\\#8B5CF6\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(139 92 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-\\[\\#E9D5FF\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-emerald-400\\/20:focus {
  --tw-ring-color: rgb(52 211 153 / 0.2);
}
.focus\\:ring-gray-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(134 239 172 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pastel-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(163 196 255 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-pastel-pink-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 179 204 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-purple-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}
.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-inset:focus-visible {
  --tw-ring-inset: inset;
}
.focus-visible\\:ring-\\[\\#28194f\\]:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(40 25 79 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-\\[\\#48247f\\]:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(72 36 127 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-\\[\\#702cb0\\]:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(112 44 176 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-\\[\\#C4B5FD\\]:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(196 181 253 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-white:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-\\[\\#48247f\\]:focus-visible {
  --tw-ring-offset-color: #48247f;
}
.active\\:scale-90:active {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-gray-100:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-gray-200:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}
.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}
.disabled\\:hover\\:translate-y-0:hover:disabled {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.disabled\\:hover\\:bg-\\[\\#F3E8FF\\]:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.disabled\\:hover\\:bg-white:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.disabled\\:hover\\:text-\\[\\#48247f\\]:hover:disabled {
  --tw-text-opacity: 1;
  color: rgb(72 36 127 / var(--tw-text-opacity, 1));
}
.disabled\\:hover\\:text-gray-400:hover:disabled {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.group[open] .group-open\\:rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[open] .group-open\\:rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group[open] .group-open\\:bg-\\[\\#12dfbd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 223 189 / var(--tw-bg-opacity, 1));
}
.group[open] .group-open\\:bg-\\[\\#e3faf5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 250 245 / var(--tw-bg-opacity, 1));
}
.group[open] .group-open\\:text-\\[\\#0f9d86\\] {
  --tw-text-opacity: 1;
  color: rgb(15 157 134 / var(--tw-text-opacity, 1));
}
.group[open] .group-open\\:text-\\[\\#102b37\\] {
  --tw-text-opacity: 1;
  color: rgb(16 43 55 / var(--tw-text-opacity, 1));
}
.group:focus-within .group-focus-within\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:block {
  display: block;
}
.group:hover .group-hover\\:flex {
  display: flex;
}
.group:hover .group-hover\\:w-full {
  width: 100%;
}
.group\\/btn:hover .group-hover\\/btn\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-translate-x-0\\.5 {
  --tw-translate-x: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-translate-x-4 {
  --tw-translate-x: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-translate-x-5 {
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-translate-y-0\\.5 {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-translate-y-1\\.5 {
  --tw-translate-y: -0.375rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:translate-y-5 {
  --tw-translate-y: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:-rotate-6 {
  --tw-rotate: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-12 {
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:rotate-3 {
  --tw-rotate: 3deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-150 {
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.04\\] {
  --tw-scale-x: 1.04;
  --tw-scale-y: 1.04;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[12\\] {
  --tw-scale-x: 12;
  --tw-scale-y: 12;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-x-100 {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-y-100 {
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:border-\\[\\#48247f\\]\\/15 {
  border-color: rgb(72 36 127 / 0.15);
}
.group:hover .group-hover\\:border-\\[\\#48247f\\]\\/20 {
  border-color: rgb(72 36 127 / 0.2);
}
.group:hover .group-hover\\:border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#12dfbd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 223 189 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#12dfbd\\]\\/15 {
  background-color: rgb(18 223 189 / 0.15);
}
.group:hover .group-hover\\:bg-\\[\\#702cb0\\]\\/25 {
  background-color: rgb(112 44 176 / 0.25);
}
.group:hover .group-hover\\:bg-\\[\\#e3faf5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(227 250 245 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#e6dcf7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 220 247 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#f1ecfa\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 236 250 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-\\[\\#f3edff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 237 255 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.group:hover .group-hover\\:bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.group:hover .group-hover\\:bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.group:hover .group-hover\\:bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.group:hover .group-hover\\:from-\\[\\#48247f\\] {
  --tw-gradient-from: #48247f var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(72 36 127 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.group:hover .group-hover\\:from-\\[\\#f3edff\\] {
  --tw-gradient-from: #f3edff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 237 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.group:hover .group-hover\\:from-blue-800 {
  --tw-gradient-from: #1e40af var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 64 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.group:hover .group-hover\\:from-purple-500\\/20 {
  --tw-gradient-from: rgb(168 85 247 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.group:hover .group-hover\\:via-purple-500 {
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.group:hover .group-hover\\:to-\\[\\#702cb0\\] {
  --tw-gradient-to: #702cb0 var(--tw-gradient-to-position);
}
.group:hover .group-hover\\:to-\\[\\#e9deff\\] {
  --tw-gradient-to: #e9deff var(--tw-gradient-to-position);
}
.group:hover .group-hover\\:to-blue-500\\/20 {
  --tw-gradient-to: rgb(59 130 246 / 0.2) var(--tw-gradient-to-position);
}
.group:hover .group-hover\\:to-blue-600 {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.group:hover .group-hover\\:text-\\[\\#0f9d86\\] {
  --tw-text-opacity: 1;
  color: rgb(15 157 134 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#102b37\\] {
  --tw-text-opacity: 1;
  color: rgb(16 43 55 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#12dfbd\\] {
  --tw-text-opacity: 1;
  color: rgb(18 223 189 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#48247f\\] {
  --tw-text-opacity: 1;
  color: rgb(72 36 127 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-\\[\\#673AB7\\] {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.group:hover .group-hover\\:text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:opacity-20 {
  opacity: 0.2;
}
.group:hover .group-hover\\:shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:hover .group-hover\\:shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group:hover .group-hover\\:shadow-\\[\\#48247f\\]\\/25 {
  --tw-shadow-color: rgb(72 36 127 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.group:hover .group-hover\\:shadow-\\[\\#48247f\\]\\/40 {
  --tw-shadow-color: rgb(72 36 127 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.group:focus-visible .group-focus-visible\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:focus-visible .group-focus-visible\\:opacity-100 {
  opacity: 1;
}
.peer:checked ~ .peer-checked\\:bg-\\[\\#673AB7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.peer:focus ~ .peer-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.peer:focus ~ .peer-focus\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.peer:focus ~ .peer-focus\\:ring-\\[\\#E9D5FF\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.peer:focus ~ .peer-focus\\:ring-blue-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:drop-shadow-xl {
    --tw-drop-shadow: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
  }

  .motion-reduce\\:transition-none {
    transition-property: none;
  }

  .motion-reduce\\:hover\\:translate-y-0:hover {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .group:hover .motion-reduce\\:group-hover\\:scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
.dark\\:divide-gray-700:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-divide-opacity, 1));
}
.dark\\:divide-gray-800:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-divide-opacity, 1));
}
.dark\\:divide-slate-700:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-divide-opacity, 1));
}
.dark\\:divide-slate-800:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-divide-opacity, 1));
}
.dark\\:border-\\[\\#111b21\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(17 27 33 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#202c33\\]\\/50:is(.dark *) {
  border-color: rgb(32 44 51 / 0.5);
}
.dark\\:border-\\[\\#323d43\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(50 61 67 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#8B5CF6\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity, 1));
}
.dark\\:border-\\[\\#E9D5FF\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.dark\\:border-amber-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}
.dark\\:border-blue-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
}
.dark\\:border-blue-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 64 175 / var(--tw-border-opacity, 1));
}
.dark\\:border-emerald-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 95 70 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}
.dark\\:border-gray-900:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(22 101 52 / var(--tw-border-opacity, 1));
}
.dark\\:border-green-900\\/50:is(.dark *) {
  border-color: rgb(20 83 45 / 0.5);
}
.dark\\:border-pink-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(157 23 77 / var(--tw-border-opacity, 1));
}
.dark\\:border-purple-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(126 34 206 / var(--tw-border-opacity, 1));
}
.dark\\:border-purple-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity, 1));
}
.dark\\:border-purple-800\\/50:is(.dark *) {
  border-color: rgb(107 33 168 / 0.5);
}
.dark\\:border-purple-900\\/50:is(.dark *) {
  border-color: rgb(88 28 135 / 0.5);
}
.dark\\:border-red-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.dark\\:border-red-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.dark\\:border-slate-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.dark\\:border-transparent:is(.dark *) {
  border-color: transparent;
}
.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.dark\\:border-yellow-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(133 77 14 / var(--tw-border-opacity, 1));
}
.dark\\:bg-\\[\\#005c4b\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 92 75 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#056162\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(5 97 98 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#0b141a\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(11 20 26 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#111b21\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 27 33 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#202c33\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(32 44 51 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#202c33\\]\\/80:is(.dark *) {
  background-color: rgb(32 44 51 / 0.8);
}
.dark\\:bg-\\[\\#233138\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 49 56 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#2a3942\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(42 57 66 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#4C2D85\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(76 45 133 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#5E35A6\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(94 53 166 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-\\[\\#673AB7\\]\\/10:is(.dark *) {
  background-color: rgb(103 58 183 / 0.1);
}
.dark\\:bg-\\[\\#673AB7\\]\\/20:is(.dark *) {
  background-color: rgb(103 58 183 / 0.2);
}
.dark\\:bg-amber-900\\/20:is(.dark *) {
  background-color: rgb(120 53 15 / 0.2);
}
.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}
.dark\\:bg-black\\/20:is(.dark *) {
  background-color: rgb(0 0 0 / 0.2);
}
.dark\\:bg-black\\/40:is(.dark *) {
  background-color: rgb(0 0 0 / 0.4);
}
.dark\\:bg-black\\/50:is(.dark *) {
  background-color: rgb(0 0 0 / 0.5);
}
.dark\\:bg-blue-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(30 58 138 / 0.2);
}
.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}
.dark\\:bg-blue-900\\/40:is(.dark *) {
  background-color: rgb(30 58 138 / 0.4);
}
.dark\\:bg-blue-900\\/50:is(.dark *) {
  background-color: rgb(30 58 138 / 0.5);
}
.dark\\:bg-emerald-900\\/30:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}
.dark\\:bg-gray-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-700\\/30:is(.dark *) {
  background-color: rgb(55 65 81 / 0.3);
}
.dark\\:bg-gray-700\\/50:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}
.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-800\\/50:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}
.dark\\:bg-gray-800\\/90:is(.dark *) {
  background-color: rgb(31 41 55 / 0.9);
}
.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-gray-900\\/30:is(.dark *) {
  background-color: rgb(17 24 39 / 0.3);
}
.dark\\:bg-gray-900\\/40:is(.dark *) {
  background-color: rgb(17 24 39 / 0.4);
}
.dark\\:bg-gray-900\\/50:is(.dark *) {
  background-color: rgb(17 24 39 / 0.5);
}
.dark\\:bg-gray-900\\/60:is(.dark *) {
  background-color: rgb(17 24 39 / 0.6);
}
.dark\\:bg-green-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-green-900\\/10:is(.dark *) {
  background-color: rgb(20 83 45 / 0.1);
}
.dark\\:bg-green-900\\/20:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}
.dark\\:bg-green-900\\/30:is(.dark *) {
  background-color: rgb(20 83 45 / 0.3);
}
.dark\\:bg-green-900\\/50:is(.dark *) {
  background-color: rgb(20 83 45 / 0.5);
}
.dark\\:bg-indigo-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-indigo-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-indigo-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-pink-900\\/30:is(.dark *) {
  background-color: rgb(131 24 67 / 0.3);
}
.dark\\:bg-purple-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(88 28 135 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-purple-900\\/30:is(.dark *) {
  background-color: rgb(88 28 135 / 0.3);
}
.dark\\:bg-purple-900\\/40:is(.dark *) {
  background-color: rgb(88 28 135 / 0.4);
}
.dark\\:bg-purple-900\\/50:is(.dark *) {
  background-color: rgb(88 28 135 / 0.5);
}
.dark\\:bg-red-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-red-900\\/10:is(.dark *) {
  background-color: rgb(127 29 29 / 0.1);
}
.dark\\:bg-red-900\\/20:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(127 29 29 / 0.3);
}
.dark\\:bg-red-900\\/50:is(.dark *) {
  background-color: rgb(127 29 29 / 0.5);
}
.dark\\:bg-sky-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(12 74 110 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-sky-900\\/30:is(.dark *) {
  background-color: rgb(12 74 110 / 0.3);
}
.dark\\:bg-slate-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-slate-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.dark\\:bg-transparent:is(.dark *) {
  background-color: transparent;
}
.dark\\:bg-white\\/5:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:bg-yellow-900\\/20:is(.dark *) {
  background-color: rgb(113 63 18 / 0.2);
}
.dark\\:bg-yellow-900\\/30:is(.dark *) {
  background-color: rgb(113 63 18 / 0.3);
}
.dark\\:bg-opacity-80:is(.dark *) {
  --tw-bg-opacity: 0.8;
}
.dark\\:from-gray-900:is(.dark *) {
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.dark\\:to-gray-800:is(.dark *) {
  --tw-gradient-to: #1f2937 var(--tw-gradient-to-position);
}
.dark\\:text-\\[\\#34D399\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#8696a0\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 150 160 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#8B5CF6\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#8b5cf6\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#C4B5FD\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#E9D5FF\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#aebac1\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(174 186 193 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#d1d7db\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 215 219 / var(--tw-text-opacity, 1));
}
.dark\\:text-\\[\\#e9edef\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(233 237 239 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.dark\\:text-black:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}
.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-400\\/80:is(.dark *) {
  color: rgb(156 163 175 / 0.8);
}
.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(187 247 208 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.dark\\:text-green-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-indigo-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.dark\\:text-pink-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.dark\\:text-purple-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 226 226 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:text-rose-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.dark\\:text-sky-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(186 230 253 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.dark\\:text-slate-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.dark\\:text-teal-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(45 212 191 / var(--tw-text-opacity, 1));
}
.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.dark\\:text-yellow-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.dark\\:placeholder-\\[\\#8696a0\\]:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(134 150 160 / var(--tw-placeholder-opacity, 1));
}
.dark\\:opacity-\\[0\\.25\\]:is(.dark *) {
  opacity: 0.25;
}
.dark\\:opacity-\\[0\\.2\\]:is(.dark *) {
  opacity: 0.2;
}
.dark\\:mix-blend-overlay:is(.dark *) {
  mix-blend-mode: overlay;
}
.dark\\:ring-gray-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-green-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 101 52 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-red-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 27 27 / var(--tw-ring-opacity, 1));
}
.dark\\:ring-slate-700:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(51 65 85 / var(--tw-ring-opacity, 1));
}
.dark\\:file\\:bg-purple-900\\/50:is(.dark *)::file-selector-button {
  background-color: rgb(88 28 135 / 0.5);
}
.dark\\:file\\:text-purple-300:is(.dark *)::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.dark\\:odd\\:bg-slate-900:nth-child(odd):is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.dark\\:even\\:bg-slate-800\\/60:nth-child(even):is(.dark *) {
  background-color: rgb(30 41 59 / 0.6);
}
.dark\\:hover\\:border-gray-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-gray-600:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-green-400:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:border-purple-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#182229\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(24 34 41 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#202c33\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(32 44 51 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#4C2D85\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(76 45 133 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-\\[\\#673AB7\\]\\/10:hover:is(.dark *) {
  background-color: rgb(103 58 183 / 0.1);
}
.dark\\:hover\\:bg-\\[\\#673AB7\\]\\/20:hover:is(.dark *) {
  background-color: rgb(103 58 183 / 0.2);
}
.dark\\:hover\\:bg-black\\/70:hover:is(.dark *) {
  background-color: rgb(0 0 0 / 0.7);
}
.dark\\:hover\\:bg-blue-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-blue-800\\/50:hover:is(.dark *) {
  background-color: rgb(30 64 175 / 0.5);
}
.dark\\:hover\\:bg-blue-900:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-blue-900\\/30:hover:is(.dark *) {
  background-color: rgb(30 58 138 / 0.3);
}
.dark\\:hover\\:bg-emerald-900\\/50:hover:is(.dark *) {
  background-color: rgb(6 78 59 / 0.5);
}
.dark\\:hover\\:bg-gray-500:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-700\\/50:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}
.dark\\:hover\\:bg-gray-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-gray-800\\/50:hover:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}
.dark\\:hover\\:bg-gray-900:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-green-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 101 52 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-green-900\\/20:hover:is(.dark *) {
  background-color: rgb(20 83 45 / 0.2);
}
.dark\\:hover\\:bg-indigo-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-purple-900\\/20:hover:is(.dark *) {
  background-color: rgb(88 28 135 / 0.2);
}
.dark\\:hover\\:bg-purple-900\\/50:hover:is(.dark *) {
  background-color: rgb(88 28 135 / 0.5);
}
.dark\\:hover\\:bg-red-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-red-900\\/20:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.2);
}
.dark\\:hover\\:bg-red-900\\/50:hover:is(.dark *) {
  background-color: rgb(127 29 29 / 0.5);
}
.dark\\:hover\\:bg-slate-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-slate-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.dark\\:hover\\:bg-teal-900\\/30:hover:is(.dark *) {
  background-color: rgb(19 78 74 / 0.3);
}
.dark\\:hover\\:bg-white\\/5:hover:is(.dark *) {
  background-color: rgb(255 255 255 / 0.05);
}
.dark\\:hover\\:text-\\[\\#673AB7\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#8B5CF6\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#E9D5FF\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#F3E8FF\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-\\[\\#FCA5A5\\]:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-blue-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-blue-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-blue-500:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-emerald-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-100:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-gray-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-green-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-green-500:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-indigo-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-purple-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-purple-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-purple-500:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-red-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-red-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-red-500:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-yellow-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:text-yellow-500:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.dark\\:hover\\:ring-gray-500:hover:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:border-indigo-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.dark\\:focus\\:ring-indigo-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
.dark\\:focus\\:ring-offset-gray-800:focus:is(.dark *) {
  --tw-ring-offset-color: #1f2937;
}
.dark\\:disabled\\:bg-gray-600:disabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.peer:focus ~ .dark\\:peer-focus\\:ring-\\[\\#5E35A6\\]:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(94 53 166 / var(--tw-ring-opacity, 1));
}
.peer:focus ~ .dark\\:peer-focus\\:ring-blue-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 64 175 / var(--tw-ring-opacity, 1));
}
@media (min-width: 640px) {

  .sm\\:inset-x-4 {
    left: 1rem;
    right: 1rem;
  }

  .sm\\:-left-24 {
    left: -6rem;
  }

  .sm\\:-right-32 {
    right: -8rem;
  }

  .sm\\:left-12 {
    left: 3rem;
  }

  .sm\\:right-4 {
    right: 1rem;
  }

  .sm\\:top-4 {
    top: 1rem;
  }

  .sm\\:top-8 {
    top: 2rem;
  }

  .sm\\:order-1 {
    order: 1;
  }

  .sm\\:order-2 {
    order: 2;
  }

  .sm\\:order-none {
    order: 0;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:-mr-10 {
    margin-right: -2.5rem;
  }

  .sm\\:-mt-24 {
    margin-top: -6rem;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-0 {
    margin-left: 0px;
  }

  .sm\\:ml-4 {
    margin-left: 1rem;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:mt-32 {
    margin-top: 8rem;
  }

  .sm\\:mt-4 {
    margin-top: 1rem;
  }

  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }

  .sm\\:mt-8 {
    margin-top: 2rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:table-cell {
    display: table-cell;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:size-4 {
    width: 1rem;
    height: 1rem;
  }

  .sm\\:size-5 {
    width: 1.25rem;
    height: 1.25rem;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:h-40 {
    height: 10rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-80 {
    height: 20rem;
  }

  .sm\\:h-9 {
    height: 2.25rem;
  }

  .sm\\:h-96 {
    height: 24rem;
  }

  .sm\\:h-\\[65vh\\] {
    height: 65vh;
  }

  .sm\\:h-\\[85px\\] {
    height: 85px;
  }

  .sm\\:h-\\[90px\\] {
    height: 90px;
  }

  .sm\\:min-h-20 {
    min-height: 5rem;
  }

  .sm\\:min-h-\\[100px\\] {
    min-height: 100px;
  }

  .sm\\:min-h-\\[2\\.35em\\] {
    min-height: 2.35em;
  }

  .sm\\:min-h-\\[620px\\] {
    min-height: 620px;
  }

  .sm\\:min-h-\\[64px\\] {
    min-height: 64px;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-24 {
    width: 6rem;
  }

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-80 {
    width: 20rem;
  }

  .sm\\:w-96 {
    width: 24rem;
  }

  .sm\\:w-\\[100px\\] {
    width: 100px;
  }

  .sm\\:w-\\[270px\\] {
    width: 270px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:max-w-2xl {
    max-width: 42rem;
  }

  .sm\\:max-w-4xl {
    max-width: 56rem;
  }

  .sm\\:max-w-lg {
    max-width: 32rem;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:max-w-xs {
    max-width: 20rem;
  }

  .sm\\:scroll-pl-0 {
    scroll-padding-left: 0px;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-normal {
    justify-content: normal;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-1 {
    gap: 0.25rem;
  }

  .sm\\:gap-12 {
    gap: 3rem;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:gap-x-5 {
    column-gap: 1.25rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:self-auto {
    align-self: auto;
  }

  .sm\\:overflow-visible {
    overflow: visible;
  }

  .sm\\:rounded-\\[2rem\\] {
    border-radius: 2rem;
  }

  .sm\\:rounded-b-\\[4rem\\] {
    border-bottom-right-radius: 4rem;
    border-bottom-left-radius: 4rem;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:p-12 {
    padding: 3rem;
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-7 {
    padding: 1.75rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:p-9 {
    padding: 2.25rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-0 {
    padding-bottom: 0px;
  }

  .sm\\:pb-12 {
    padding-bottom: 3rem;
  }

  .sm\\:pb-14 {
    padding-bottom: 3.5rem;
  }

  .sm\\:pb-16 {
    padding-bottom: 4rem;
  }

  .sm\\:pb-20 {
    padding-bottom: 5rem;
  }

  .sm\\:pb-24 {
    padding-bottom: 6rem;
  }

  .sm\\:pb-36 {
    padding-bottom: 9rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-0 {
    padding-left: 0px;
  }

  .sm\\:pl-2 {
    padding-left: 0.5rem;
  }

  .sm\\:pl-\\[4\\.75rem\\] {
    padding-left: 4.75rem;
  }

  .sm\\:pr-0 {
    padding-right: 0px;
  }

  .sm\\:pr-10 {
    padding-right: 2.5rem;
  }

  .sm\\:pt-16 {
    padding-top: 4rem;
  }

  .sm\\:pt-24 {
    padding-top: 6rem;
  }

  .sm\\:pt-28 {
    padding-top: 7rem;
  }

  .sm\\:pt-36 {
    padding-top: 9rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .sm\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .sm\\:text-\\[21px\\] {
    font-size: 21px;
  }

  .sm\\:text-\\[26px\\] {
    font-size: 26px;
  }

  .sm\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .sm\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .sm\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .sm\\:text-\\[34px\\] {
    font-size: 34px;
  }

  .sm\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .sm\\:text-\\[42px\\] {
    font-size: 42px;
  }

  .sm\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 768px) {

  .md\\:absolute {
    position: absolute;
  }

  .md\\:bottom-6 {
    bottom: 1.5rem;
  }

  .md\\:left-6 {
    left: 1.5rem;
  }

  .md\\:left-auto {
    left: auto;
  }

  .md\\:right-0 {
    right: 0px;
  }

  .md\\:top-\\[calc\\(100\\%\\+10px\\)\\] {
    top: calc(100% + 10px);
  }

  .md\\:order-1 {
    order: 1;
  }

  .md\\:order-2 {
    order: 2;
  }

  .md\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .md\\:mb-16 {
    margin-bottom: 4rem;
  }

  .md\\:mb-4 {
    margin-bottom: 1rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:table-cell {
    display: table-cell;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-3\\.5 {
    height: 0.875rem;
  }

  .md\\:h-4 {
    height: 1rem;
  }

  .md\\:h-5 {
    height: 1.25rem;
  }

  .md\\:h-7 {
    height: 1.75rem;
  }

  .md\\:h-8 {
    height: 2rem;
  }

  .md\\:h-\\[14px\\] {
    height: 14px;
  }

  .md\\:h-\\[18px\\] {
    height: 18px;
  }

  .md\\:h-\\[70vh\\] {
    height: 70vh;
  }

  .md\\:max-h-80 {
    max-height: 20rem;
  }

  .md\\:max-h-\\[90vh\\] {
    max-height: 90vh;
  }

  .md\\:min-h-0 {
    min-height: 0px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-1\\/4 {
    width: 25%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-3\\.5 {
    width: 0.875rem;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-4 {
    width: 1rem;
  }

  .md\\:w-40 {
    width: 10rem;
  }

  .md\\:w-5 {
    width: 1.25rem;
  }

  .md\\:w-56 {
    width: 14rem;
  }

  .md\\:w-64 {
    width: 16rem;
  }

  .md\\:w-7 {
    width: 1.75rem;
  }

  .md\\:w-80 {
    width: 20rem;
  }

  .md\\:w-\\[14px\\] {
    width: 14px;
  }

  .md\\:w-\\[18px\\] {
    width: 18px;
  }

  .md\\:w-\\[350px\\] {
    width: 350px;
  }

  .md\\:w-\\[85vw\\] {
    width: 85vw;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:max-w-2xl {
    max-width: 42rem;
  }

  .md\\:max-w-3xl {
    max-width: 48rem;
  }

  .md\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .md\\:max-w-lg {
    max-width: 32rem;
  }

  .md\\:max-w-md {
    max-width: 28rem;
  }

  .md\\:max-w-sm {
    max-width: 24rem;
  }

  .md\\:max-w-xl {
    max-width: 36rem;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:shrink {
    flex-shrink: 1;
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1fr_1fr_1fr_auto\\] {
    grid-template-columns: 1fr 1fr 1fr auto;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-16 {
    gap: 4rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:rounded-full {
    border-radius: 9999px;
  }

  .md\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .md\\:border-0 {
    border-width: 0px;
  }

  .md\\:border-l-4 {
    border-left-width: 4px;
  }

  .md\\:border-\\[\\#12dfbd\\] {
    --tw-border-opacity: 1;
    border-color: rgb(18 223 189 / var(--tw-border-opacity, 1));
  }

  .md\\:bg-transparent {
    background-color: transparent;
  }

  .md\\:p-1 {
    padding: 0.25rem;
  }

  .md\\:p-2\\.5 {
    padding: 0.625rem;
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-7 {
    padding: 1.75rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:p-9 {
    padding: 2.25rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:pl-5 {
    padding-left: 1.25rem;
  }

  .md\\:pr-9 {
    padding-right: 2.25rem;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .md\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .md\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .md\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .md\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .md\\:text-\\[34px\\] {
    font-size: 34px;
  }

  .md\\:text-\\[36px\\] {
    font-size: 36px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .md\\:text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  }

  .md\\:text-gray-500 {
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1));
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .md\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .md\\:before\\:hidden::before {
    content: var(--tw-content);
    display: none;
  }

  .group:hover .md\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
}
@media (min-width: 1024px) {

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:-right-20 {
    right: -5rem;
  }

  .lg\\:left-4 {
    left: 1rem;
  }

  .lg\\:left-8 {
    left: 2rem;
  }

  .lg\\:top-14 {
    top: 3.5rem;
  }

  .lg\\:top-24 {
    top: 6rem;
  }

  .lg\\:z-40 {
    z-index: 40;
  }

  .lg\\:z-50 {
    z-index: 50;
  }

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:-mx-14 {
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .lg\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .lg\\:-mr-14 {
    margin-right: -3.5rem;
  }

  .lg\\:-mt-28 {
    margin-top: -7rem;
  }

  .lg\\:mb-14 {
    margin-bottom: 3.5rem;
  }

  .lg\\:mb-16 {
    margin-bottom: 4rem;
  }

  .lg\\:mb-20 {
    margin-bottom: 5rem;
  }

  .lg\\:mb-24 {
    margin-bottom: 6rem;
  }

  .lg\\:ml-10 {
    margin-left: 2.5rem;
  }

  .lg\\:ml-20 {
    margin-left: 5rem;
  }

  .lg\\:ml-4 {
    margin-left: 1rem;
  }

  .lg\\:ml-64 {
    margin-left: 16rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-16 {
    margin-top: 4rem;
  }

  .lg\\:mt-24 {
    margin-top: 6rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:table-cell {
    display: table-cell;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-14 {
    height: 3.5rem;
  }

  .lg\\:h-\\[100px\\] {
    height: 100px;
  }

  .lg\\:h-\\[38px\\] {
    height: 38px;
  }

  .lg\\:h-\\[500px\\] {
    height: 500px;
  }

  .lg\\:h-\\[66px\\] {
    height: 66px;
  }

  .lg\\:h-\\[68px\\] {
    height: 68px;
  }

  .lg\\:h-\\[70vh\\] {
    height: 70vh;
  }

  .lg\\:min-h-\\[680px\\] {
    min-height: 680px;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-20 {
    width: 5rem;
  }

  .lg\\:w-5\\/12 {
    width: 41.666667%;
  }

  .lg\\:w-64 {
    width: 16rem;
  }

  .lg\\:w-7\\/12 {
    width: 58.333333%;
  }

  .lg\\:w-\\[400px\\] {
    width: 400px;
  }

  .lg\\:max-w-2xl {
    max-width: 42rem;
  }

  .lg\\:max-w-3xl {
    max-width: 48rem;
  }

  .lg\\:max-w-4xl {
    max-width: 56rem;
  }

  .lg\\:max-w-\\[400px\\] {
    max-width: 400px;
  }

  .lg\\:max-w-lg {
    max-width: 32rem;
  }

  .lg\\:max-w-none {
    max-width: none;
  }

  .lg\\:max-w-xl {
    max-width: 36rem;
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[0\\.8fr_1\\.2fr\\] {
    grid-template-columns: 0.8fr 1.2fr;
  }

  .lg\\:grid-cols-\\[1\\.05fr_1fr\\] {
    grid-template-columns: 1.05fr 1fr;
  }

  .lg\\:grid-cols-\\[1\\.15fr_0\\.85fr\\] {
    grid-template-columns: 1.15fr 0.85fr;
  }

  .lg\\:grid-cols-\\[1fr_1\\.05fr\\] {
    grid-template-columns: 1fr 1.05fr;
  }

  .lg\\:grid-cols-\\[1fr_1fr\\] {
    grid-template-columns: 1fr 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_250px\\] {
    grid-template-columns: minmax(0,1fr) 250px;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-12 {
    gap: 3rem;
  }

  .lg\\:gap-14 {
    gap: 3.5rem;
  }

  .lg\\:gap-16 {
    gap: 4rem;
  }

  .lg\\:gap-20 {
    gap: 5rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:space-x-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--tw-space-x-reverse));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:self-start {
    align-self: flex-start;
  }

  .lg\\:whitespace-nowrap {
    white-space: nowrap;
  }

  .lg\\:rounded-\\[3rem\\] {
    border-radius: 3rem;
  }

  .lg\\:border-l-4 {
    border-left-width: 4px;
  }

  .lg\\:border-\\[\\#12dfbd\\] {
    --tw-border-opacity: 1;
    border-color: rgb(18 223 189 / var(--tw-border-opacity, 1));
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-14 {
    padding: 3.5rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-14 {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .lg\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:pb-16 {
    padding-bottom: 4rem;
  }

  .lg\\:pb-20 {
    padding-bottom: 5rem;
  }

  .lg\\:pb-24 {
    padding-bottom: 6rem;
  }

  .lg\\:pb-40 {
    padding-bottom: 10rem;
  }

  .lg\\:pl-5 {
    padding-left: 1.25rem;
  }

  .lg\\:pr-14 {
    padding-right: 3.5rem;
  }

  .lg\\:pt-16 {
    padding-top: 4rem;
  }

  .lg\\:pt-20 {
    padding-top: 5rem;
  }

  .lg\\:pt-24 {
    padding-top: 6rem;
  }

  .lg\\:pt-32 {
    padding-top: 8rem;
  }

  .lg\\:pt-40 {
    padding-top: 10rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-\\[17px\\] {
    font-size: 17px;
  }

  .lg\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .lg\\:text-\\[34px\\] {
    font-size: 34px;
  }

  .lg\\:text-\\[36px\\] {
    font-size: 36px;
  }

  .lg\\:text-\\[38px\\] {
    font-size: 38px;
  }

  .lg\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .lg\\:text-\\[48px\\] {
    font-size: 48px;
  }

  .lg\\:text-\\[54px\\] {
    font-size: 54px;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 1280px) {

  .xl\\:left-12 {
    left: 3rem;
  }

  .xl\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .xl\\:-mr-20 {
    margin-right: -5rem;
  }

  .xl\\:table-cell {
    display: table-cell;
  }

  .xl\\:h-\\[70vh\\] {
    height: 70vh;
  }

  .xl\\:w-\\[480px\\] {
    width: 480px;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:gap-14 {
    gap: 3.5rem;
  }

  .xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .xl\\:pr-20 {
    padding-right: 5rem;
  }

  .xl\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .xl\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .xl\\:text-\\[42px\\] {
    font-size: 42px;
  }

  .xl\\:text-\\[44px\\] {
    font-size: 44px;
  }
}
.\\[\\&\\:\\:-webkit-details-marker\\]\\:hidden::-webkit-details-marker {
  display: none;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&_\\*\\]\\:transition-all * {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\[\\&_\\*\\]\\:duration-300 * {
  transition-duration: 300ms;
}
.\\[\\&_rect\\]\\:transition-colors rect {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\[\\&_rect\\]\\:duration-300 rect {
  transition-duration: 300ms;
}
.hover\\:\\[\\&_rect\\]\\:fill-\\[\\#12dfbd\\] rect:hover {
  fill: #12dfbd;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,aAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,4BAA4B;AAC5B;EACE,uDAAuD;AACzD;;AAEA,mBAAmB;AACnB;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,oCAAoC;AACtC;AAhCA;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,qBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,qBAgCC;EAhCD;AAgCC;AAhCD;EAAA,mBAgCC;EAhCD;AAgCC;AAhCD;EAAA,mBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD,wBAgCC;EAhCD,wDAgCC;EAhCD;AAgCC;AAhCD;EAAA,gBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,2BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,2BAgCC;EAhCD;AAgCC;AAhCD;EAAA,yBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,yBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,iBAgCC;EAhCD,iBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,4DAgCC;EAhCD,oEAgCC;EAhCD;AAgCC;AAhCD;EAAA,4DAgCC;EAhCD,oEAgCC;EAhCD;AAgCC;AAhCD;EAAA,4DAgCC;EAhCD,mEAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,0EAgCC;EAhCD,8FAgCC;EAhCD;AAgCC;AAhCD;EAAA,gDAgCC;EAhCD,6DAgCC;EAhCD;AAgCC;AAhCD;EAAA,mDAgCC;EAhCD,6DAgCC;EAhCD;AAgCC;AAhCD;EAAA,mDAgCC;EAhCD,6DAgCC;EAhCD;AAgCC;AAhCD;EAAA,mDAgCC;EAhCD,6DAgCC;EAhCD;AAgCC;AAhCD;EAAA,kDAgCC;EAhCD,6DAgCC;EAhCD;AAgCC;AAhCD;EAAA,6CAgCC;EAhCD,sDAgCC;EAhCD;AAgCC;AAhCD;EAAA,6CAgCC;EAhCD,sDAgCC;EAhCD;AAgCC;AAhCD;EAAA,iDAgCC;EAhCD,2DAgCC;EAhCD;AAgCC;AAhCD;EAAA,+EAgCC;EAhCD,mGAgCC;EAhCD;AAgCC;AAhCD;EAAA,6EAgCC;EAhCD,iGAgCC;EAhCD;AAgCC;AAhCD;EAAA,0CAgCC;EAhCD,uDAgCC;EAhCD;AAgCC;AAhCD;EAAA,gFAgCC;EAhCD,oGAgCC;EAhCD;AAgCC;AAhCD;EAAA,wCAgCC;EAhCD;AAgCC;AAhCD;EAAA,uCAgCC;EAhCD;AAgCC;AAhCD;EAAA,wCAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,gBAgCC;EAhCD,WAgCC;EAhCD,YAgCC;EAhCD,UAgCC;EAhCD,SAgCC;EAhCD,iBAgCC;EAhCD,UAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,mBAgCC;EAhCD;AAgCC;AAhCD;EAAA,mBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,+EAgCC;EAhCD,mGAgCC;EAhCD;AAgCC;AAhCD;EAAA,8BAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,8BAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,gBAgCC;EAhCD,gBAgCC;EAhCD;AAgCC;AAhCD;EAAA,iBAgCC;EAhCD,iBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,qBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,mBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,yBAgCC;EAhCD;AAgCC;AAhCD;EAAA,2BAgCC;EAhCD;AAgCC;AAhCD;EAAA,uBAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,2BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,2BAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD;AAgCC;AAhCD;EAAA,yBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,yBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,qBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,yBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,iBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,iBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,iBAgCC;EAhCD,iBAgCC;EAhCD;AAgCC;AAhCD;EAAA,iBAgCC;EAhCD,iBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,gBAgCC;EAhCD,gBAgCC;EAhCD;AAgCC;AAhCD;EAAA,eAgCC;EAhCD;AAgCC;AAhCD;EAAA,eAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,4DAgCC;EAhCD,mEAgCC;EAhCD;AAgCC;AAhCD;EAAA,4DAgCC;EAhCD,qEAgCC;EAhCD;AAgCC;AAhCD;EAAA,4DAgCC;EAhCD,mEAgCC;EAhCD;AAgCC;AAhCD;EAAA,0EAgCC;EAhCD,oEAgCC;EAhCD;AAgCC;AAhCD;EAAA,qEAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,+EAgCC;EAhCD,mGAgCC;EAhCD;AAgCC;AAhCD;EAAA,6EAgCC;EAhCD,iGAgCC;EAhCD;AAgCC;AAhCD;EAAA,wCAgCC;EAhCD;AAgCC;AAhCD;EAAA,uCAgCC;EAhCD;AAgCC;AAhCD;EAAA,qBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,0BAgCC;EAhCD,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,8BAgCC;EAhCD;AAgCC;AAhCD;EAAA,2GAgCC;EAhCD,yGAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;;EAAA;IAAA,qGAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,eAgCC;IAhCD,eAgCC;IAhCD;EAgCC;AAAA;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,4DAgCC;EAhCD,kEAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,2BAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,sBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,kBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;EAAA,oBAgCC;EAhCD;AAgCC;AAhCD;;EAAA;IAAA,UAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,gBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,gBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,WAgCC;IAhCD;EAgCC;;EAhCD;IAAA,cAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,uBAgCC;IAhCD,sDAgCC;IAhCD;EAgCC;;EAhCD;IAAA,uBAgCC;IAhCD,uDAgCC;IAhCD;EAgCC;;EAhCD;IAAA,uBAgCC;IAhCD,2DAgCC;IAhCD;EAgCC;;EAhCD;IAAA,uBAgCC;IAhCD,4DAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,gCAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,eAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;AAAA;AAhCD;;EAAA;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,gBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,sBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,gBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,eAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,eAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,sBAgCC;IAhCD,8BAgCC;IAhCD;EAgCC;;EAhCD;IAAA,0BAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;AAAA;AAhCD;;EAAA;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,gBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,uBAgCC;IAhCD,uDAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,sBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,oBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,mBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,qBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,iBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,eAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;AAAA;AAhCD;;EAAA;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA,kBAgCC;IAhCD;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;;EAhCD;IAAA;EAgCC;AAAA;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,wBAgCC;EAhCD,wDAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA,+FAgCC;EAhCD,wDAgCC;EAhCD;AAgCC;AAhCD;EAAA;AAgCC;AAhCD;EAAA;AAgCC","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n/* Smooth theme transition */\r\nhtml {\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n/* Thin Scrollbar */\r\n.scrollbar-thin::-webkit-scrollbar {\r\n  width: 4px;\r\n  /* thin */\r\n}\r\n\r\n.scrollbar-thin::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.scrollbar-thin::-webkit-scrollbar-thumb {\r\n  background: #181818;\r\n  border-radius: 10px;\r\n}\r\n\r\n.scrollbar-thin::-webkit-scrollbar-thumb:hover {\r\n  background: #151515;\r\n}\r\n\r\n/* For Firefox */\r\n.scrollbar-thin {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #363636 transparent;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
